<template>
  <div class="flex justify-center">
    <div class="flex items-center justify-center rounded-full bg-success-100 h-12 w-12 mb-2">
      <CheckCircle2 class="h-8 w-8 text-success-400" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { CheckCircle2 } from 'lucide-vue-next';
</script>
